import type { DefaultError } from '@hc-frontend/core-utils-business-operation';

export type FeaturesLoggerError = 'failOnPerformOperationLog' | DefaultError;

export const FEATURES_LOGGER_ERRORS: Record<FeaturesLoggerError, string> = {
  failOnPerformOperationLog: 'Error while performing an operation log',
  unexpectedException: 'Exception while executing operation',
  unhandledOperationError: 'Unhandled operation error',
  unknownException: 'Unknown exception',
} as const;

export type FeaturesLoggerErrorCatalog = Record<FeaturesLoggerError, string>;
